import qs from 'query-string';

import XOS_LOGO from '../images/xos-logo-rw.png';
import CATAPULT_LOGO from '../images/catapult-logo-bw.png';

const CATAPULT_SPORTS = 'catapult';

const XOS_BRANDING = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  SECONDARY: '#A6A6A6',
  PRIMARY: '#FE0302',
};

const CATAPULT_BRANDING = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  SECONDARY: '#A6A6A6',
  PRIMARY: '#FF6600',
};

export function getProductBranding(productName) {
  if (productName === CATAPULT_SPORTS) {
    return CATAPULT_BRANDING;
  }

  return XOS_BRANDING;
}

export function getProductLogo(productName) {
  if (productName === CATAPULT_SPORTS) {
    return CATAPULT_LOGO;
  }

  return XOS_LOGO;
}

export function parseProductNameFromURLQuery(query) {
  const { app_url: productUrl } = qs.parse(query);

  if (!productUrl) {
    return null;
  }

  const localhostRegex = /^https?:\/\/localhost/;
  if (localhostRegex.test(productUrl)) {
    const url = new URL(productUrl);
    const { query: { product } } = qs.parseUrl(url.search);

    if (!product) {
      return null;
    }

    return product;
  }

  try {
    let productQueryName = productUrl.split('//')[1].split('.')[0];
    if (productQueryName.includes('-')) {
      [productQueryName] = productQueryName.split('-');
    }
    return productQueryName;
  } catch (e) {
    return null;
  }
}
